import React from 'react'
import SubmitArticle from '../../../components/common/submitArticle'
import DashboardLayout from '../../../layout/dashboard'

const EditArticle = () => {
  return (
    <DashboardLayout>
      <SubmitArticle />
    </DashboardLayout>
  )
}

export default EditArticle